import { memo, useMemo } from "react";

import Badge from "ds/components/Badge";
import { ArrowsLeftRight } from "components/icons/generated";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";

import { type RenderResourceRowCellProps } from ".";
import useCellFilterAction from "../useCellFilterAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementResourceCell from "../components/ResourceCell";

const IacManagementTableResourceRowCellDrifted = memo((props: RenderResourceRowCellProps) => {
  const { row } = props;

  const driftedFilterAction = useCellFilterAction(
    ResourcesSuggestions.Drifted,
    (!!row.drifted).toString()
  );
  const actions = useMemo(() => [driftedFilterAction], [driftedFilterAction]);

  return (
    <IacManagementResourceCell {...props} actions={actions}>
      {(row.drifted && (
        <Badge type="weak" variant="yellow" startIcon={ArrowsLeftRight} iconOnly />
      )) || <TableCellEmpty />}
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellDrifted.displayName = "IacManagementTableResourceRowCellDrifted";

export default IacManagementTableResourceRowCellDrifted;
